export const BARCELO_LANDING_NAME = 'barcelo'
export const NAUTALIA_LANDING_NAME = 'nautalia'
export const CARREFOUR_LANDING_NAME = 'viajescarrefour'
export const MSM_LANDING_NAME = 'msm'
export const IBEROSTAR_LANDING_NAME = 'iberostar'
export const WAMOS_LANDING_NAME = 'wamos'
export const ASSEGUR_LANDING_NAME = 'assegur'
export const UNIHEALTH_LANDING_NAME = 'unihealth'

export function GET_TRAVEL_COMPANIES () { 
    return [
        BARCELO_LANDING_NAME,
        NAUTALIA_LANDING_NAME,
        CARREFOUR_LANDING_NAME,
        IBEROSTAR_LANDING_NAME,
        WAMOS_LANDING_NAME,
        ASSEGUR_LANDING_NAME
    ]
}

export function isTravelCompany (company) {
    return GET_TRAVEL_COMPANIES().includes(company)
}


// WEBPACK FOOTER //
// ./src/constants/companiesLandingNames.js